import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { ProductPdfState } from 'b2b-apps/shop/product/redux/productPdf/types';

const getState = (state: State)
    : ProductPdfState => state.product.productPdf;

const getProductPdfState = (state: State)
    : ProductPdfState => getState(state) || {};

const getProductPdfDownload = (state: State)
    : RemoteRecord<any> => new RemoteRecord(getProductPdfState(state).download);

const getProductPdfPrint = (state: State)
    : RemoteRecord<any> => new RemoteRecord(getProductPdfState(state).print);

export {
  getProductPdfDownload,
  getProductPdfPrint,
  getState,
};
